export default __webpack_public_path__ + "static/media/furniture-bg-9.9fb72d8a.png";